<template>
  <div :class="componentClassName">
    <a-button
      :id="'audio-backward'"
      class="a-audio-player-control-backward"
      variant="icon"
      icon="audio-backward"
      icon-color="orange"
      @click="handleBackward"
    />

    <a-button
      :id="'audio-play'"
      class="a-audio-player-control-play"
      variant="icon"
      :icon="controlIcon"
      icon-color="white"
      color="primary"
      size="small"
      @click="handlePlayPause"
    />

    <a-button
      :id="'audio-forward'"
      class="a-audio-player-control-forward"
      variant="icon"
      icon="audio-forward"
      icon-color="orange"
      @click="handleForward"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';

export default {
  name: 'a-audio-player-control',
  components: {
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: 'orange',
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['forward', 'backward', 'play', 'pause'],
  data() {
    return {
      playing: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-audio-player-control');
      return `${baseClassName} ${this.class}`.trim();
    },
    controlIcon() {
      return this.playing ? 'audio-pause' : 'audio-play';
    },
  },
  watch: {
    isPlaying(val) {
      this.playing = val;
    },
  },
  mounted() {
    if (this.isPlaying) {
      this.playing = this.isPlaying;
    }
  },
  methods: {
    handleForward(event) {
      this.$emit('forward', event);
    },
    handleBackward(event) {
      this.$emit('backward', event);
    },
    handlePlayPause(event) {
      if (this.playing) {
        this.$emit('pause', event);
        this.playing = false;
      } else {
        this.$emit('play', event);
        this.playing = true;
      }
    },
  },
};
</script>
